<template>
  <el-select v-model="v" filterable default-first-option remote :remote-method="handelRemoteCustomer"
             placeholder="请输入名称关键词选择客户" :size="size" clearable>
    <el-option v-for="item in optionsCustomers" :key="item.customer_id" :label="item.customer_name"
               :value="item.customer_id"/>
  </el-select>
</template>

<script>
import {optionsSaleCustomers} from "@/api/customers";

const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).value : {id: -1}
const user_id = user.id

export default {
  name: "SelectCustomerMine",
  props: ['value', 'size'],
  data() {
    return {
      v: null,
      optionsCustomers: [],
    }
  },
  watch: {
    value(_) {
      this.v = _
    },
    v(_) {
      this.$emit('update:value', _)
      const obj = this.optionsCustomers.find(item => {
        return item.customer_id === _
      })
      if (obj) {
        this.$emit('update:name', obj.customer_name)
      }
      this.$nextTick(() => {
        this.$emit('change')
      })
    }
  },
  methods: {
    async handelRemoteCustomer(query) {
      const response = await optionsSaleCustomers({customer_name: query, sale_id: user_id})
      this.optionsCustomers = response.model || []
    }
  }
}
</script>

<style scoped>

</style>
